'use client';
import { useTranslations } from 'next-intl';
import { BaseLineCopy } from '@/app/components/icons/BaseLineCopy';
import { BaseLineReset } from '@/app/components/icons/BaseLineReset';
import { Dialog, DialogContent } from '@/app/components/ui/dialog';
import { useCopy } from '@/app/hooks';

export interface GetTokenDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  token: string;
  onReset: () => void;
}

export const GetTokenDialog = ({ open, onOpenChange, token, onReset }: GetTokenDialogProps) => {
  const t = useTranslations();
  const { copy } = useCopy();

  const handleCopy = () => {
    if (!token) {
      return;
    }
    copy(token);
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          onOpenChange(false);
        }
      }}
    >
      <DialogContent className="flex max-w-[632px] flex-col gap-2 rounded-16 border border-[rgba(255,255,255,0.12)] bg-[#121316]">
        <div className="flex items-center">
          <div className="font-medium text-base text-white">{t('popup.dialog.getToken.title')}</div>
        </div>

        <div className="whitespace-pre-line text-system-white64 text-xs">{t('popup.dialog.getToken.description')}</div>

        <div className="flex items-center justify-between rounded-8 border border-system-white12 bg-black px-4 py-3">
          <div className="min-w-0 flex-1 truncate text-white text-xs">{token || '-'}</div>
          <div className="ml-3 flex shrink-0 items-center">
            <div
              className="flex cursor-pointer items-center gap-1 rounded-8 px-2 py-1 text-system-white64 text-xs hover:bg-system-white16 hover:text-system-white"
              onClick={handleCopy}
            >
              <BaseLineCopy className="size-4 text-system-white64" />
              <span>{t('popup.dialog.getToken.copy')}</span>
            </div>

            <div className="mx-1 h-4 w-px bg-white/16" />
            <div
              className="flex cursor-pointer items-center gap-1 rounded-8 px-2 py-1 text-system-white64 text-xs hover:bg-system-white16 hover:text-system-white"
              onClick={onReset}
            >
              <BaseLineReset className="size-4" />
              <span>{t('popup.dialog.getToken.reset')}</span>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
